<span class="d-block">Identification de l'avis initial publié au BOAMP</span>

<app-form-input
    [parentForm]="parentForm"
    [value]="avisInitial?.idWeb"
    [disabled]="disabled"
    [label]="'Identifiant de l\'annonce sur le boamp.fr'"
    [type]="'text'" [rule]="'pattern_9|required'" [errorMessage]="{'pattern' : 'ctr_pattern9'}"
    [name]="getUid()+'_SepAtt_idWeb'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="avisInitial?.datePublication"
[label]="'Date de publication'"
[type]="'date'" [rule]="''"
[name]="getUid()+'_SepAtt_datePublication'">
</app-form-input>
